import { Form, Spin, Typography } from "antd/es";
import { connect } from "react-redux";
import {
  HorizontalStack,
  Icon,
  KCol,
  KRow,
  Label,
  LayoutHeader,
  LayoutLeft,
  Menu,
  MenuItem,
  VerticalStack,
} from "../../components/web-components";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer,
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { withContext } from "../../shared/hoc/with-context";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { NewLayout_ScreenBase } from "./newlayout-base";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [
  { key: "3080", screenName: "Anasayfa", params: {}, isStartingScreen: false },
  {
    key: "639329",
    screenName: "Customer_List",
    params: {},
    isStartingScreen: false,
  },
  {
    key: "381039",
    screenName: "Station_List",
    params: {},
    isStartingScreen: false,
  },
  {
    key: "618547",
    screenName: "Product_List",
    params: {},
    isStartingScreen: false,
  },
  {
    key: "145566",
    screenName: "STDBoxes_List",
    params: {},
    isStartingScreen: false,
  },
  {
    key: "871167",
    screenName: "Orders_List",
    params: {},
    isStartingScreen: false,
  },
  {
    key: "814917",
    screenName: "STDUsers_List",
    params: {},
    isStartingScreen: false,
  },
  {
    key: "863101",
    screenName: "UserGroup_List",
    params: {},
    isStartingScreen: false,
  },
  {
    key: "58560",
    screenName: "EslestirmeTeslimTesellum",
    params: {},
    isStartingScreen: false,
  },
  {
    key: "435686",
    screenName: "MailGroups",
    params: {},
    isStartingScreen: false,
  },
  {
    key: "432620",
    screenName: "SQLQueryScreen",
    params: {},
    isStartingScreen: false,
  },
];

class NewLayout_Screen extends NewLayout_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Spin spinning={this.state.spinnerCount > 0}>
          <Form
            form={this.props.form}
            name="basic"
            initialValues={{
              ...this.props.initialValues,
              newlayout_276318_value: { collapsed: false, selectedKey: "" },
            }}
            onValuesChange={(changedValues, allValues) => {
              this.clearFieldValidation(changedValues);
            }}
          >
            <div style={{} as any}>
              <div style={{ display: "flex" } as any}>
                <LayoutLeft
                  key="-12"
                  id="Minus12"
                  id="newlayout_layout_left"
                  layoutPosition={1}
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "rgba(255, 255, 255, 1)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "left",
                      paddingTop: 0,
                      paddingRight: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      width: "100px",
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      fontSize: "14px",
                      color: "rgba(68, 68, 68, 1)",
                    } as any
                  }
                >
                  <KRow
                    key="337799"
                    id="337799"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  >
                    <KCol
                      key="571992"
                      id="571992"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "center",
                          textAlign: "-webkit-left",
                        } as any
                      }
                    >
                      <HorizontalStack
                        key="848346"
                        id="848346"
                        direction="horizontal"
                        size={12}
                        overflowX="auto"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <Icon
                          key="723060"
                          id="723060"
                          iconName="all_inbox"
                          style={
                            {
                              borderTopLeftRadius: 12,
                              borderTopRightRadius: 12,
                              borderBottomRightRadius: 12,
                              borderBottomLeftRadius: 12,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(17, 82, 212, 1)",
                              paddingTop: 12,
                              paddingRight: 12,
                              paddingBottom: 12,
                              paddingLeft: 12,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "20px",
                              color: "rgba(255, 255, 255, 1)",
                              letterSpacing: "1px",
                            } as any
                          }
                        ></Icon>
                        <VerticalStack
                          key="685455"
                          id="685455"
                          direction="vertical"
                          size={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              textAlign: "-webkit-left",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <Label
                            key="441792"
                            id="441792"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              441792,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Montserrat",
                                fontWeight: 700,
                                fontSize: "22px",
                                color: "rgba(17, 82, 212, 1)",
                              } as any
                            }
                          ></Label>
                          <Label
                            key="510622"
                            id="510622"
                            value={ReactSystemFunctions.translate(
                              this.ml,
                              510622,
                              "value",
                              this.defaultML
                            )}
                            writingMode="horizontal"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "12px",
                                color: "rgba(190, 199, 212, 1)",
                                lineHeight: "20px",
                              } as any
                            }
                          ></Label>
                        </VerticalStack>
                      </HorizontalStack>
                    </KCol>
                  </KRow>
                  <KRow
                    key="887909"
                    id="887909"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  >
                    <KCol
                      key="725092"
                      id="725092"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                        } as any
                      }
                    >
                      <Form.Item
                        className="kFormItem"
                        name="newlayout_276318_value"
                        noStyle
                      >
                        <Menu
                          key="276318"
                          id="276318"
                          menuMap={menuMap}
                          options={this.state.dataSource_276318}
                          mode="vertical"
                          theme="light"
                          primaryColor="rgba(17, 82, 212, 1)"
                          collapsible={false}
                          collapsedButtonColor="rgba(17, 82, 212, 1)"
                          hamburgerControl={false}
                          closeSiblingSubmenusOnOpen={false}
                          style={
                            {
                              backgroundColor: "transparent",
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              width: "100%",
                            } as any
                          }
                        >
                          <MenuItem
                            key={3080}
                            id="3080"
                            onClick={(e?: any) => {
                              if (e && e.stopPropagation) e.stopPropagation();
                              this.NewLayoutComponent_3080_onClick();
                            }}
                            showCursorPointer
                            key={3080}
                            label={ReactSystemFunctions.translate(
                              this.ml,
                              3080,
                              "label",
                              this.defaultML
                            )}
                            icon="dashboard"
                            style={
                              {
                                paddingTop: 4,
                                paddingBottom: 4,
                                fontFamily: "Montserrat",
                                fontWeight: 600,
                                color: "rgba(17, 82, 212, 1)",
                              } as any
                            }
                          ></MenuItem>
                          <MenuItem
                            key={639329}
                            id="639329"
                            onClick={(e?: any) => {
                              if (e && e.stopPropagation) e.stopPropagation();
                              this.NewLayoutComponent_639329_onClick();
                            }}
                            showCursorPointer
                            visibility={this.state.isComp639329Visible}
                            visibilityCondition={(rowData: object) =>
                              ReactSystemFunctions.isEqualTo(
                                this.state.GetUserWithGroupDetails[0]?.customerView?.toString(),
                                true
                              )
                            }
                            key={639329}
                            label={ReactSystemFunctions.translate(
                              this.ml,
                              639329,
                              "label",
                              this.defaultML
                            )}
                            icon="support_agent"
                            style={
                              {
                                paddingTop: 4,
                                paddingBottom: 4,
                                fontFamily: "Montserrat",
                                fontWeight: 600,
                                color: "rgba(36, 105, 204, 1)",
                              } as any
                            }
                          ></MenuItem>
                          <MenuItem
                            key={381039}
                            id="381039"
                            onClick={(e?: any) => {
                              if (e && e.stopPropagation) e.stopPropagation();
                              this.NewLayoutComponent_381039_onClick();
                            }}
                            showCursorPointer
                            visibility={this.state.isComp381039Visible}
                            visibilityCondition={(rowData: object) =>
                              ReactSystemFunctions.isEqualTo(
                                this.state.GetUserWithGroupDetails[0]?.stationsView?.toString(),
                                true
                              )
                            }
                            key={381039}
                            label={ReactSystemFunctions.translate(
                              this.ml,
                              381039,
                              "label",
                              this.defaultML
                            )}
                            icon="business"
                            style={
                              {
                                paddingTop: 4,
                                paddingBottom: 4,
                                fontFamily: "Montserrat",
                                fontWeight: 600,
                                color: "rgba(36, 105, 204, 1)",
                              } as any
                            }
                          ></MenuItem>
                          <MenuItem
                            key={618547}
                            id="618547"
                            onClick={(e?: any) => {
                              if (e && e.stopPropagation) e.stopPropagation();
                              this.NewLayoutComponent_618547_onClick();
                            }}
                            showCursorPointer
                            visibility={this.state.isComp618547Visible}
                            visibilityCondition={(rowData: object) =>
                              ReactSystemFunctions.isEqualTo(
                                this.state.GetUserWithGroupDetails[0]?.productsView?.toString(),
                                true
                              )
                            }
                            key={618547}
                            label={ReactSystemFunctions.translate(
                              this.ml,
                              618547,
                              "label",
                              this.defaultML
                            )}
                            icon="adjust"
                            style={
                              {
                                paddingTop: 4,
                                paddingBottom: 4,
                                fontFamily: "Montserrat",
                                fontWeight: 600,
                                color: "rgba(36, 105, 204, 1)",
                              } as any
                            }
                          ></MenuItem>
                          <MenuItem
                            key={145566}
                            id="145566"
                            onClick={(e?: any) => {
                              if (e && e.stopPropagation) e.stopPropagation();
                              this.NewLayoutComponent_145566_onClick();
                            }}
                            showCursorPointer
                            visibility={this.state.isComp145566Visible}
                            visibilityCondition={(rowData: object) =>
                              ReactSystemFunctions.isEqualTo(
                                this.state.GetUserWithGroupDetails[0]?.boxView?.toString(),
                                true
                              )
                            }
                            key={145566}
                            label={ReactSystemFunctions.translate(
                              this.ml,
                              145566,
                              "label",
                              this.defaultML
                            )}
                            icon="inventory_2"
                            style={
                              {
                                paddingTop: 4,
                                paddingBottom: 4,
                                color: "rgba(36, 105, 204, 1)",
                              } as any
                            }
                          ></MenuItem>
                          <MenuItem
                            key={871167}
                            id="871167"
                            onClick={(e?: any) => {
                              if (e && e.stopPropagation) e.stopPropagation();
                              this.NewLayoutComponent_871167_onClick();
                            }}
                            showCursorPointer
                            visibility={this.state.isComp871167Visible}
                            visibilityCondition={(rowData: object) =>
                              ReactSystemFunctions.isEqualTo(
                                this.state.GetUserWithGroupDetails[0]?.orderView?.toString(),
                                true
                              )
                            }
                            key={871167}
                            label={ReactSystemFunctions.translate(
                              this.ml,
                              871167,
                              "label",
                              this.defaultML
                            )}
                            icon="transfer_within_a_station"
                            style={
                              {
                                paddingTop: 4,
                                paddingBottom: 4,
                                fontFamily: "Montserrat",
                                fontWeight: 600,
                                color: "rgba(36, 105, 204, 1)",
                              } as any
                            }
                          ></MenuItem>
                          <MenuItem
                            key={814917}
                            id="814917"
                            onClick={(e?: any) => {
                              if (e && e.stopPropagation) e.stopPropagation();
                              this.NewLayoutComponent_814917_onClick();
                            }}
                            showCursorPointer
                            visibility={this.state.isComp814917Visible}
                            visibilityCondition={(rowData: object) =>
                              ReactSystemFunctions.isEqualTo(
                                this.state.GetUserWithGroupDetails[0]?.usersView?.toString(),
                                true
                              )
                            }
                            key={814917}
                            label={ReactSystemFunctions.translate(
                              this.ml,
                              814917,
                              "label",
                              this.defaultML
                            )}
                            icon="admin_panel_settings"
                            style={
                              {
                                paddingTop: 4,
                                paddingBottom: 4,
                                fontFamily: "Montserrat",
                                fontWeight: 600,
                                color: "rgba(36, 105, 204, 1)",
                              } as any
                            }
                          ></MenuItem>
                          <MenuItem
                            key={863101}
                            id="863101"
                            onClick={(e?: any) => {
                              if (e && e.stopPropagation) e.stopPropagation();
                              this.NewLayoutComponent_863101_onClick();
                            }}
                            showCursorPointer
                            visibility={this.state.isComp863101Visible}
                            visibilityCondition={(rowData: object) =>
                              ReactSystemFunctions.isEqualTo(
                                this.state.GetUserWithGroupDetails[0]?.userGroupView?.toString(),
                                true
                              )
                            }
                            key={863101}
                            label={ReactSystemFunctions.translate(
                              this.ml,
                              863101,
                              "label",
                              this.defaultML
                            )}
                            icon="groups"
                            style={
                              {
                                paddingTop: 4,
                                paddingBottom: 4,
                                fontFamily: "Montserrat",
                                fontWeight: 600,
                                color: "rgba(36, 105, 204, 1)",
                              } as any
                            }
                          ></MenuItem>
                          <MenuItem
                            key={58560}
                            id="58560"
                            onClick={(e?: any) => {
                              if (e && e.stopPropagation) e.stopPropagation();
                              this.NewLayoutComponent_58560_onClick();
                            }}
                            showCursorPointer
                            visibility={this.state.isComp58560Visible}
                            key={58560}
                            label={ReactSystemFunctions.translate(
                              this.ml,
                              58560,
                              "label",
                              this.defaultML
                            )}
                            icon="qr_code"
                            style={
                              {
                                paddingTop: 4,
                                paddingBottom: 4,
                                fontFamily: "Montserrat",
                                fontWeight: 600,
                                color: "rgba(36, 105, 204, 1)",
                              } as any
                            }
                          ></MenuItem>
                          <MenuItem
                            key={435686}
                            id="435686"
                            onClick={(e?: any) => {
                              if (e && e.stopPropagation) e.stopPropagation();
                              this.NewLayoutComponent_435686_onClick();
                            }}
                            showCursorPointer
                            visibility={
                              this.state
                                .isCompnewlayout_435686AuthorizationVisible
                            }
                            visibilityByAuthorization={
                              this.state
                                .isCompnewlayout_435686AuthorizationVisible
                            }
                            key={435686}
                            label={ReactSystemFunctions.translate(
                              this.ml,
                              435686,
                              "label",
                              this.defaultML
                            )}
                            icon="qr_code"
                            style={
                              {
                                paddingTop: 4,
                                paddingBottom: 4,
                                fontFamily: "Montserrat",
                                fontWeight: 600,
                                color: "rgba(36, 105, 204, 1)",
                              } as any
                            }
                          ></MenuItem>
                          <MenuItem
                            key={432620}
                            id="432620"
                            onClick={(e?: any) => {
                              if (e && e.stopPropagation) e.stopPropagation();
                              this.NewLayoutComponent_432620_onClick();
                            }}
                            showCursorPointer
                            visibility={this.state.isComp432620Visible}
                            visibilityCondition={(rowData: object) =>
                              ReactSystemFunctions.isEqualTo(
                                ReactSystemFunctions.getMyUsername(),
                                "omer.kavas@normdigital.com"
                              )
                            }
                            key={432620}
                            label={ReactSystemFunctions.translate(
                              this.ml,
                              432620,
                              "label",
                              this.defaultML
                            )}
                            icon="search"
                            style={
                              {
                                paddingTop: 4,
                                paddingBottom: 4,
                                fontFamily: "Montserrat",
                                fontWeight: 600,
                                color: "rgba(36, 105, 204, 1)",
                              } as any
                            }
                          ></MenuItem>
                        </Menu>
                      </Form.Item>
                    </KCol>
                  </KRow>
                  <KRow
                    key="715384"
                    id="715384"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  >
                    <KCol
                      key="32603"
                      id="32603"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderTopWidth: 1,
                          borderColor: "rgba(217, 217, 217, 1)",
                          borderStyle: "solid",
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                        } as any
                      }
                    >
                      <HorizontalStack
                        key="716067"
                        id="716067"
                        direction="horizontal"
                        size={12}
                        overflowX="auto"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 24,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <Icon
                          key="430915"
                          id="430915"
                          iconName="logout"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "20px",
                              color: "rgba(225, 60, 57, 1)",
                              letterSpacing: "1px",
                            } as any
                          }
                        ></Icon>
                        <Label
                          key="486218"
                          id="486218"
                          onClick={(e?: any) => {
                            if (e && e.stopPropagation) e.stopPropagation();
                            this.NewLayoutComponent_486218_onClick();
                          }}
                          showCursorPointer
                          value={ReactSystemFunctions.translate(
                            this.ml,
                            486218,
                            "value",
                            this.defaultML
                          )}
                          writingMode="horizontal"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              width: "100px",
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(225, 60, 57, 1)",
                            } as any
                          }
                        ></Label>
                      </HorizontalStack>
                    </KCol>
                  </KRow>
                </LayoutLeft>
                <div
                  id="masterRootDI_wrapper"
                  style={{ flex: "auto", background: "#f0f2f5" } as any}
                >
                  <LayoutHeader
                    key="-10"
                    id="Minus10"
                    id="newlayout_layout_header"
                    layoutPosition={2}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        backgroundColor: "rgba(255, 255, 255, 1)",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        backgroundPosition: "left",
                        paddingTop: 0,
                        paddingRight: 0,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        minHeight: "60px",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KRow
                      key="42808"
                      id="42808"
                      align="top"
                      justify="start"
                      horizontalGutter={0}
                      verticalGutter={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "center",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KCol
                        key="253202"
                        id="253202"
                        xs={8}
                        sm={8}
                        md={8}
                        lg={8}
                        xl={8}
                        xxl={8}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      ></KCol>
                      <KCol
                        key="553847"
                        id="553847"
                        xs={8}
                        sm={8}
                        md={8}
                        lg={8}
                        xl={8}
                        xxl={8}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      ></KCol>
                      <KCol
                        key="876915"
                        id="876915"
                        xs={8}
                        sm={8}
                        md={8}
                        lg={8}
                        xl={8}
                        xxl={8}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "center",
                            textAlign: "-webkit-right",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <HorizontalStack
                          key="620097"
                          id="620097"
                          direction="horizontal"
                          size={12}
                          overflowX="auto"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <VerticalStack
                            key="283676"
                            id="283676"
                            direction="vertical"
                            size={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                textAlign: "-webkit-right",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <Label
                              key="698695"
                              id="698695"
                              value={
                                this.state.GetUserWithGroupDetails?.at?.(0)
                                  ?.fullName ?? undefined
                              }
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "inline",
                                  fontFamily: "Roboto",
                                  fontWeight: 600,
                                  fontSize: "14px",
                                  color: "rgba(126, 130, 141, 1)",
                                } as any
                              }
                            ></Label>
                            <Label
                              key="812279"
                              id="812279"
                              value={
                                this.state.GetUserWithGroupDetails?.at?.(0)
                                  ?.groupName ?? undefined
                              }
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "inline",
                                  fontFamily: "Poppins",
                                  fontWeight: 600,
                                  fontSize: "12px",
                                  color: "rgba(190, 199, 212, 1)",
                                  lineHeight: "20px",
                                } as any
                              }
                            ></Label>
                          </VerticalStack>
                          <Icon
                            key="564983"
                            id="564983"
                            iconName="account_circle"
                            style={
                              {
                                borderTopLeftRadius: 28,
                                borderTopRightRadius: 28,
                                borderBottomRightRadius: 28,
                                borderBottomLeftRadius: 28,
                                borderTopWidth: 1,
                                borderRightWidth: 1,
                                borderBottomWidth: 1,
                                borderLeftWidth: 1,
                                borderColor: "rgba(17, 82, 212, 1)",
                                borderStyle: "solid",
                                paddingTop: "",
                                paddingRight: "",
                                paddingBottom: "",
                                paddingLeft: 0,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "36px",
                                color: "rgba(17, 82, 212, 1)",
                                letterSpacing: "1px",
                              } as any
                            }
                          ></Icon>
                        </HorizontalStack>
                      </KCol>
                    </KRow>
                  </LayoutHeader>
                  <div style={{ display: "flex" } as any}>
                    <div
                      id="masterRootDI"
                      style={
                        {
                          flex: "auto",
                          overflow: "hidden auto",
                          maxWidth: "100vw",
                          width: 0,
                          position: "relative",
                          height: "calc(100vh - 66px)",
                        } as any
                      }
                    >
                      <>{this.props.children}</>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible:
      state.importMappedExcelModalReducer.visible,
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) =>
    dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) =>
    dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) =>
    dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) =>
    dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (
    dsId,
    tableName,
    primaryKey,
    columnMapping,
    parameters
  ) =>
    dispatch(
      showImportMappedExcelModal(
        dsId,
        tableName,
        primaryKey,
        columnMapping,
        parameters
      )
    ),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal()),
});
const tmp = withGoogleLogin(
  withContext(
    withScreenInput(
      withHistory(
        connect(mapStateToProps, mapDispatchToProps)(NewLayout_Screen)
      )
    )
  )
);
export { tmp as NewLayout_Screen };
//export default tmp;
//export { tmp as NewLayout_Screen };
